import { SxProps } from '@mui/material';
import { TableRow } from 'shared/mui/Table';

import { TableCellHeaderStyled, TableCellStyled } from './TableRowWrapper.styled';

export type TableRowWrapperProps = {
  label: React.ReactNode;
  children?: React.ReactNode;
  headerStyle?: SxProps;
  contentStyle?: SxProps;
};

export const TableRowWrapper = ({
  label,
  children,
  headerStyle,
  contentStyle,
}: TableRowWrapperProps): JSX.Element => (
  <TableRow>
    <TableCellHeaderStyled label={label} sx={headerStyle} />
    <TableCellStyled component="th" scope="row" sx={contentStyle}>
      {children}
    </TableCellStyled>
  </TableRow>
);
